import * as React from 'react'
import { useController, useForm } from 'react-hook-form'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'

import * as styles from './LegalTerm.module.scss'
import { tradeMarkSymbolParser } from 'util/titleParser'

export const LegalTerm = ({
  name,
  label,
  register,
  error,
  required,
  control,
  defaultChecked,
}) => {
  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    name,
    control,
    rules: { required: true },
  })

  return (
    <>
      <FormControlLabel
        sx={{
          marginRight: '0',
        }}
        classes={{
          root: styles.labelCheckboxClass,
        }}
        slotProps={{
          typography: {
            sx: {
              fontSize: '0.75rem',
            },
          },
        }}
        key={label}
        control={
          <Checkbox
            size="medium"
            {...register(name, { required: required })}
            classes={{
              root: styles.checkboxClass,
              checked: styles.checked,
            }}
            defaultChecked={defaultChecked}
            onChange={field.onChange}
            name={name}
          />
        }
        label={
          <>
            {required ? <span className={styles.asterisk}>*</span> : null}{' '}
            <span
              className={styles.label}
              dangerouslySetInnerHTML={{
                __html: tradeMarkSymbolParser(label),
              }}
            />
          </>
        }
      />

      {error && (
        <FormHelperText error={true} id={name}>
          {error.message || 'This field is required'}
        </FormHelperText>
      )}
    </>
  )
}
